export enum ActionTypeKeys {
    SAVE_REPORT_REQUEST = 'SAVE_TECHNICIAN_REPORT_REQUEST',
    SAVE_REPORT_SUCCESS = 'SAVE_TECHNICIAN_REPORT_SUCCESS',
    SAVE_REPORT_FAILURE = 'SAVE_TECHNICIAN_REPORT_FAILURE',
    
    LOAD_REPORT_REQUEST = 'LOAD_TECHNICIAN_REPORT_REQUEST',
    LOAD_REPORT_SUCCESS = 'LOAD_TECHNICIAN_REPORT_SUCCESS',
    LOAD_REPORT_FAILURE = 'LOAD_TECHNICIAN_REPORT_FAILURE',
}